import { zodResolver } from '@hookform/resolvers/zod';
import { Group, Stack } from '@mantine/core';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FacultyDepartmentSelectControl } from '@/module/Setup/components/FacultyDepartmentSelectControl';
import { SetupSchema } from '@/module/Setup/model/SetupSchema';

import { Content, Form, FormSubmit, TextInputControl } from '@/core/components';

import { JobTitleSelectControl } from '@feature/utils';

type UserSetupFormProps = FormSubmit<SetupSchema>;

export function UserSetupForm(props: UserSetupFormProps) {
  const { schema, defaultValues, values, isSubmitting, onCancel, onSubmit } = props;
  const { t } = useTranslation();
  const form = useForm<SetupSchema>({
    defaultValues,
    values,
    resolver: zodResolver(schema),
  });
  const { control } = form;

  return (
    <FormProvider {...form}>
      <Form
        isSubmitting={isSubmitting}
        onCancel={onCancel}
        onSubmit={form.handleSubmit(onSubmit)}
      >
        <Stack>
          <Content type="full">
            <Group>
              <TextInputControl
                control={control}
                name="lastName"
                label={t('setup.fields.lastName')}
                isSubmitting={isSubmitting}
              />
              <TextInputControl
                control={control}
                name="firstName"
                label={t('setup.fields.firstName')}
                isSubmitting={isSubmitting}
              />
            </Group>
            <JobTitleSelectControl
              control={control}
              name="jobTitle"
              label={t('setup.fields.jobTitle')}
              isSubmitting={isSubmitting}
            />
            <FacultyDepartmentSelectControl
              control={control}
              isSubmitting={isSubmitting}
            />
          </Content>
        </Stack>
      </Form>
    </FormProvider>
  );
}
